export default __webpack_public_path__ + "static/media/vitalsDashboard.58a8360f.svg";